import { AppState } from '../../../../types'

const selectors: any = {
  getAll: (state: AppState) => state.monitoring.logPoints.apis,
  state: (state: AppState) => selectors.getAll(state).logPoints,
  isLoadingLogPoints: (state: AppState) => selectors.getAll(state).loadingLogPoints,
  isSaving: (state: AppState) => selectors.getAll(state).savingLogPoints,
  hasSavedYet: (state: AppState) => selectors.getAll(state).hasSavedYet,
  applicationFullDomain: (state: AppState) => selectors.getAll(state).applicationFullDomain,
  isRuntimeVerifiable: (state: AppState) => selectors.getAll(state).isRuntimeVerifiable,
  error: (state: AppState) => selectors.getAll(state).error
}

export default selectors
